export default "__VITE_ASSET__e2a61440__"